<div [class.selected]="selected" [style.background-color]="backgroundColor" class="card ion-activatable ripple-parent">
  <ion-ripple-effect *ngIf="hasRippleEffect" role="presentation"></ion-ripple-effect>
  <ng-content select="app-card-content"></ng-content>
  <div class="spacer"></div>
  <div class="card-image-wrapper">
    <ng-content select="app-card-image"></ng-content>
  </div>
</div>
